<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch"
      >
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :editable="true"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
            <!-- <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button> -->
            <el-button type="text" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="loading"
                type="primary"
                size="mini"
                @click="del(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deleteId } from "@/api/basic/projectPhase";
import {tableSataus} from '@/views/bill/mixins/status'

export default {
  name: "",
  mixins: [DataTableMixin,tableSataus],
  components: {
    DynamicSearch
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  data() {
    return {
      total: 1,
      tableHead: [
        {
          label: "单据编号",
          prop: "code",
          align: "center"
        },
        {
          label: "模板名称",
          prop: "name",
          query: {
            type: "input"
          },
          align: "center"
        },
        {
          label: "提交日期",
          prop: "created",
          align: "center"
        },
        // {
        //   label: "最后修改日期",
        //   prop: "modified",
        //   align: "center"
        // },
        //  {
        //   label: "状态",
        //   prop: "billState",
        //     formatter: (state) => {
        //       return this.statusName(state)
        //     }
        // }
      ],
      tableData: []
    };
  },
  methods: {
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/bs-project-milestone`;
      const params = { page: this.page, size: this.offset, };
      this._params = Object.assign(params, this._query);
      return true;
    },
    add() {
      this.$router.push({ path: "/projectPhase/form", query: {isEdit: 1} });
    },
     view(data) {
      this.$router.push({ path: "/projectPhase/form", query: { id: data.id ,isEdit: 0} });
    },
     // 修改
    edit(data) {
      this.$router.push({ path: "/projectPhase/form", query: { id: data.id ,isEdit: 1} });
    },
   audit(data) { // 审核
      data.bizProjectPlan = {id: data.id,billState: 3}
      this.updata(data);
       this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },

    // 4回退 5 反审核
    reject(data, status = 4) {
       data.bizProjectPlan = {id: data.id, billState: status}
      this.updata(data);
       this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },
      updata(data) {
    },
    // 删除
    del(id) {
      if (id) {
        this.loading = true;
        deleteId(id).then(res => {
          if (res.code === 200) {
            this.loading = false;
            this.$notify({
              title: '删除成功',
              type: 'success',
              duration: 2500
            })
            this.$nextTick(() => {
              this.dataTableInit();
            });
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  height: 100%;
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
